import {
  FieldUI,
  FormField,
} from '@labrav/react-components/lib/@types/types/forms'
import {
  apnProgramOptions,
  closedReasonOptions,
  competitiveTrackingOptions,
  countryOptions,
  currencyOptions,
  deliveryModelOptions,
  industryOptions,
  marketingActivityChannelOptions,
  marketingActivityUseCaseOptions,
  opportunityTypeOptions,
  partnerPrimaryNeedFromAWSOptions,
  procurementTypesOptions,
  partnerSalesContactTitleOptions,
  salesActivitiesOptions,
  stateOptions,
  useCaseOptions,
} from '../../../common/utils/CoSellHelpers/constants'

export const contactsFormFields: Array<FormField> = [
  {
    title: 'First name',
    placeHolder: 'First name',
    id: 'partnerContactFirstName',
    isRequired: false,
    humanReadableKey: 'Labra__Primary_Sales_Rep_First_Name__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Last name',
    placeHolder: 'Last name',
    id: 'partnerContactLastName',
    isRequired: false,
    humanReadableKey: 'Labra__Primary_Sales_Rep_Last_Name__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Title',
    placeHolder: 'Title',
    id: 'partnerSalesContactTitle',
    isRequired: false,
    humanReadableKey: 'Labra__Partner_Contact_Title__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: partnerSalesContactTitleOptions,
  },
  {
    title: 'Email',
    placeHolder: 'Email',
    id: 'partnerSalesContactEmail',
    isRequired: false,
    humanReadableKey: 'Labra__Primary_Sales_Rep_Email__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Phone',
    placeHolder: 'Phone',
    id: 'partnerSalesContactPhone',
    isRequired: false,
    humanReadableKey: 'Labra__Primary_Sales_Rep_Phone__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
]

export const customerPrivateFields: Array<FormField> = [
  {
    title: 'First name',
    placeHolder: 'First name',
    id: 'firstName',
    isRequired: false,
    humanReadableKey: 'Labra__Customer_First_Name__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Last name',
    placeHolder: 'Last name',
    id: 'lastName',
    isRequired: false,
    humanReadableKey: 'Labra__Customer_Last_Name__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Title',
    placeHolder: 'Title',
    id: 'title',
    isRequired: false,
    humanReadableKey: 'Labra__Customer_Title__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Email',
    placeHolder: 'Email',
    id: 'email',
    isRequired: false,
    humanReadableKey: 'Labra__Customer_Email__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Phone',
    placeHolder: 'Phone',
    id: 'phone',
    isRequired: false,
    humanReadableKey: 'Labra__Customer_Phone__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
]

export const customerFields: Array<FieldUI & FormField> = [
  {
    title: 'Company name',
    placeHolder: '',
    id: 'companyName',
    isRequired: true,
    humanReadableKey: 'Labra__Company_Name__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Website',
    placeHolder: '',
    id: 'website',
    isRequired: true,
    humanReadableKey: 'Labra__Website__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Select a country',
    placeHolder: '',
    id: 'country',
    isRequired: true,
    humanReadableKey: 'Labra__Country__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: countryOptions,
  },
  {
    title: 'State (Optional)',
    placeHolder: '',
    id: 'state',
    isRequired: false,
    humanReadableKey: 'Labra__State__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: stateOptions,
  },
  {
    title: 'City (Optional)',
    placeHolder: '',
    id: 'city',
    isRequired: false,
    humanReadableKey: 'Labra__City__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Postal code',
    placeHolder: '',
    id: 'postalCode',
    isRequired: true,
    humanReadableKey: 'Labra__Postal_Code__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Address (Optional)',
    placeHolder: '',
    id: 'streetAddress',
    isRequired: false,
    humanReadableKey: 'Labra__Street_Address__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'DUNS (Optional)',
    placeHolder: '',
    id: 'duns',
    isRequired: false,
    humanReadableKey: 'Labra__Customer_DUNS__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Industry',
    placeHolder: '',
    id: 'industry',
    isRequired: true,
    humanReadableKey: 'Labra__Industry__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: industryOptions,
  },
  {
    title: 'Other industry',
    placeHolder: '',
    id: 'otherIndustry',
    isRequired: false,
    humanReadableKey: 'Labra__Other_Industry__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Select if this involves restricted national security info',
    placeHolder: '',
    id: 'hasClassifiedNationalSecurityInformation',
    isRequired: false,
    humanReadableKey: 'Labra__Has_classified_NatSec_Information__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: ['Yes', 'No'],
  },
]

export const saasDocumentationFields: Array<FormField> = [
  {
    title: 'Contract effective date',
    placeHolder: '',
    id: 'contractEffectiveDate',
    isRequired: false,
    humanReadableKey: 'contractEffectiveDate',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'date',
    info: 'The date when the customer contract becomes active.',
  },
  {
    title: 'Contract expiration date',
    placeHolder: '',
    id: 'contractExpirationDate',
    isRequired: false,
    humanReadableKey: 'contractExpirationDate',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'date',
    info: 'The date when the contract term ends.',
  },
  {
    title: 'Currency',
    placeHolder: '',
    id: 'currency',
    isRequired: false,
    humanReadableKey: 'currency',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: currencyOptions,
    info: 'Currency in which the Total Contract Value (TCV) is agreed.',
  },
  {
    title: 'Customer software value (TCV)',
    placeHolder: '',
    id: 'customerSoftwareValue',
    isRequired: false,
    humanReadableKey: 'title',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'integer',
    info: 'Enter the full contract value for the entire agreement duration. This should represent total committed revenue, not monthly or annual value unless it is a 1-year contract.',
  },
  {
    title: 'Procurement type',
    placeHolder: '',
    id: 'procurementType',
    isRequired: false,
    humanReadableKey: 'procurementType',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: procurementTypesOptions,
  },
]

export const segmentAndGreenField: Array<FieldUI & FormField> = [
  {
    title: 'Customer Segment',
    placeHolder: 'Customer Segment',
    id: 'customerSegment',
    dataType: 'string',
    isRequired: false,
    humanReadableKey: 'Labra__Customer_Segment__c',
    isReadOnly: true,
    isCustom: false,
    defaultValue: undefined,
    columns: 12,
  },
  {
    title: 'Is Greenfield',
    placeHolder: 'Is Greenfield',
    id: 'isGreenfield',
    dataType: 'string',
    isRequired: false,
    humanReadableKey: 'Labra__isGreenfield__c',
    isReadOnly: true,
    isCustom: false,
    defaultValue: undefined,
    columns: 12,
    maxLength: 255,
  },
]

export const awsDetailsFields: Array<FieldUI & FormField> = [
  {
    title: 'APN Programs',
    placeHolder: '',
    id: 'apnProgram',
    isRequired: false,
    humanReadableKey: 'Labra__Campaign_Name__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'multi_enum',
    columns: 12,
    options: apnProgramOptions,
  },
  {
    title: 'Select AWS products (Optional)',
    placeHolder: '',
    id: 'awsProducts',
    isRequired: false,
    humanReadableKey: 'Labra__AWS_products__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'multi_enum',
    columns: 12,
    options: [
      {
        label: 'AWS AI Factories',
        value: 'AWSAIFactories',
      },
      {
        label: 'AWS Agent Registry',
        value: 'AWSAgentRegistry',
      },
      {
        label: 'AWS Amplify',
        value: 'AWSAmplify',
      },
      {
        label: 'AWS App2Container',
        value: 'AWSApp2Container',
      },
      {
        label: 'AWS AppFabric',
        value: 'AWSAppFabric',
      },
      {
        label: 'AWS App Mesh',
        value: 'AWSAppMesh',
      },
      {
        label: 'AWS App Runner',
        value: 'AWSAppRunner',
      },
      {
        label: 'AWS App Studio',
        value: 'AWSAppStudio',
      },
      {
        label: 'AWS AppSync',
        value: 'AWSAppSync',
      },
      {
        label: 'AWS Application Cost Profiler',
        value: 'AWSApplicationCostProfiler',
      },
      {
        label: 'AWS Application Migration Service (MGN)',
        value: 'AWSApplicationMigrationServiceMGN',
      },
      {
        label: 'AWS Assurance',
        value: 'AWSAssurance',
      },
      {
        label: 'AWS Audit Manager',
        value: 'AWSAuditManager',
      },
      {
        label: 'AWS B2B Data Interchange',
        value: 'AWSB2BDataInterchange',
      },
      {
        label: 'AWS Backup',
        value: 'AWSBackup',
      },
      {
        label: 'AWS Batch',
        value: 'AWSBatch',
      },
      {
        label: 'AWS Billing Conductor',
        value: 'AWSBillingConductor',
      },
      {
        label: 'AWS BugBust',
        value: 'AWSBugBust',
      },
      {
        label: 'AWS Business Support+',
        value: 'AWSBusinessSupport',
      },
      {
        label: 'AWS Certificate Manager',
        value: 'AWSCertificateManager',
      },
      {
        label: 'AWS Chatbot',
        value: 'AWSChatbot',
      },
      {
        label: 'AWS Clean Rooms',
        value: 'AWSCleanRooms',
      },
      {
        label: 'AWS Clean Rooms Differential Privacy',
        value: 'AWSCleanRoomsDifferentialPrivacy',
      },
      {
        label: 'AWS Clean Rooms ML',
        value: 'AWSCleanRoomsML',
      },
      {
        label: 'AWS Client VPN',
        value: 'AWSClientVPN',
      },
      {
        label: 'AWS Cloud9',
        value: 'AWSCloud9',
      },
      {
        label: 'AWS Cloud Control API',
        value: 'AWSCloudControlAPI',
      },
      {
        label: 'AWS Cloud Development Kit (CDK)',
        value: 'AWSCloudDevelopmentKitCDK',
      },
      {
        label: 'AWS CloudFormation',
        value: 'AWSCloudFormation',
      },
      {
        label: 'AWS CloudHSM',
        value: 'AWSCloudHSM',
      },
      {
        label: 'AWS Cloud Map',
        value: 'AWSCloudMap',
      },
      {
        label: 'AWS CloudShell',
        value: 'AWSCloudShell',
      },
      {
        label: 'AWS CloudTrail',
        value: 'AWSCloudTrail',
      },
      {
        label: 'AWS Cloud WAN',
        value: 'AWSCloudWAN',
      },
      {
        label: 'AWS CodeArtifact',
        value: 'AWSCodeArtifact',
      },
      {
        label: 'AWS CodeBuild',
        value: 'AWSCodeBuild',
      },
      {
        label: 'AWS CodeCommit',
        value: 'AWSCodeCommit',
      },
      {
        label: 'AWS CodeDeploy',
        value: 'AWSCodeDeploy',
      },
      {
        label: 'AWS CodePipeline',
        value: 'AWSCodePipeline',
      },
      {
        label: 'AWS CodeStar',
        value: 'AWSCodeStar',
      },
      {
        label: 'AWS Config',
        value: 'AWSConfig',
      },
      {
        label: 'AWS Console Mobile Application',
        value: 'AWSConsoleMobileApplication',
      },
      {
        label: 'AWS Control Tower',
        value: 'AWSControlTower',
      },
      {
        label: 'AWS Countdown Premium',
        value: 'AWSCountdownPremium',
      },
      {
        label: 'AWS Data Exchange',
        value: 'AWSDataExchange',
      },
      {
        label: 'AWS DataSync',
        value: 'AWSDataSync',
      },
      {
        label: 'AWS Data Transfer Terminal',
        value: 'AWSDataTransferTerminal',
      },
      {
        label: 'AWS Database Migration Service',
        value: 'AWSDatabaseMigrationService',
      },
      {
        label: 'AWS Deadline Cloud',
        value: 'AWSDeadlineCloud',
      },
      {
        label: 'AWS Dedicated Local Zones',
        value: 'AWSDedicatedLocalZones',
      },
      {
        label: 'AWS DeepComposer',
        value: 'AWSDeepComposer',
      },
      {
        label: 'AWS Deep Learning AMIs',
        value: 'AWSDeepLearningAMIs',
      },
      {
        label: 'AWS Deep Learning Containers',
        value: 'AWSDeepLearningContainers',
      },
      {
        label: 'AWS DeepLens',
        value: 'AWSDeepLens',
      },
      {
        label: 'AWS DeepRacer',
        value: 'AWSDeepRacer',
      },
      {
        label: 'AWS DevOps Agent',
        value: 'AWSDevOpsAgent',
      },
      {
        label: 'AWS Device Farm',
        value: 'AWSDeviceFarm',
      },
      {
        label: 'AWS Diode',
        value: 'AWSDiode',
      },
      {
        label: 'AWS Direct Connect',
        value: 'AWSDirectConnect',
      },
      {
        label: 'AWS Directory Service',
        value: 'AWSDirectoryService',
      },
      {
        label: 'AWS Distro for OpenTelemetry (ADOT)',
        value: 'AWSDistroforOpenTelemetryADOT',
      },
      {
        label: 'AWS Elastic Beanstalk',
        value: 'AWSElasticBeanstalk',
      },
      {
        label: 'AWS Elastic Disaster Recovery',
        value: 'AWSElasticDisasterRecovery',
      },
      {
        label: 'AWS Elemental Inference',
        value: 'AWSElementalInference',
      },
      {
        label: 'AWS Elemental MediaConnect',
        value: 'AWSElementalMediaConnect',
      },
      {
        label: 'AWS Elemental MediaConvert',
        value: 'AWSElementalMediaConvert',
      },
      {
        label: 'AWS Elemental MediaLive',
        value: 'AWSElementalMediaLive',
      },
      {
        label: 'AWS Elemental MediaLive Anywhere',
        value: 'AWSElementalMediaLiveAnywhere',
      },
      {
        label: 'AWS Elemental MediaPackage',
        value: 'AWSElementalMediaPackage',
      },
      {
        label: 'AWS Elemental MediaStore',
        value: 'AWSElementalMediaStore',
      },
      {
        label: 'AWS Elemental MediaTailor',
        value: 'AWSElementalMediaTailor',
      },
      {
        label: 'AWS End User Messaging',
        value: 'AWSEndUserMessaging',
      },
      {
        label: 'AWS End User Messaging Social',
        value: 'AWSEndUserMessagingSocial',
      },
      {
        label: 'AWS End-of-Support Migration Program (EMP)',
        value: 'AWSEndofSupportMigrationProgramEMP',
      },
      {
        label: 'AWS Enterprise Support',
        value: 'AWSEnterpriseSupport',
      },
      {
        label: 'AWS Enterprise Support - Public Pricing',
        value: 'AWSEnterpriseSupportPublicPricing',
      },
      {
        label: 'AWS Entity Resolution',
        value: 'AWSEntityResolution',
      },
      {
        label: 'AWS Fault Injection Service (FIS)',
        value: 'AWSFaultInjectionServiceFIS',
      },
      {
        label: 'AWS Firewall Manager',
        value: 'AWSFirewallManager',
      },
      {
        label: 'AWS GameKit',
        value: 'AWSGameKit',
      },
      {
        label: 'AWS Global Accelerator',
        value: 'AWSGlobalAccelerator',
      },
      {
        label: 'AWS Glue',
        value: 'AWSGlue',
      },
      {
        label: 'AWS Glue DataBrew',
        value: 'AWSGlueDataBrew',
      },
      {
        label: 'AWS Ground Station',
        value: 'AWSGroundStation',
      },
      {
        label: 'AWS HealthImaging',
        value: 'AWSHealthImaging',
      },
      {
        label: 'AWS HealthScribe',
        value: 'AWSHealthScribe',
      },
      {
        label: 'AWS IAM Access Analyzer',
        value: 'AWSIAMAccessAnalyzer',
      },
      {
        label: 'AWS Incident Detection and Response',
        value: 'AWSIncidentDetectionandResponse',
      },
      {
        label: 'AWS Infrastructure Event Management',
        value: 'AWSInfrastructureEventManagement',
      },
      {
        label: 'AWS IoT Core',
        value: 'AWSIoTCore',
      },
      {
        label: 'AWS IoT Core for LoRaWAN',
        value: 'AWSIoTCoreforLoRaWAN',
      },
      {
        label: 'AWS IoT Device Defender',
        value: 'AWSIoTDeviceDefender',
      },
      {
        label: 'AWS IoT Device Management',
        value: 'AWSIoTDeviceManagement',
      },
      {
        label: 'AWS IoT FleetWise',
        value: 'AWSIoTFleetWise',
      },
      {
        label: 'AWS IoT Greengrass',
        value: 'AWSIoTGreengrass',
      },
      {
        label: 'AWS IoT Greengrass nucleus lite',
        value: 'AWSIoTGreengrassnucleuslite',
      },
      {
        label: 'AWS IoT SiteWise',
        value: 'AWSIoTSiteWise',
      },
      {
        label: 'AWS IoT TwinMaker',
        value: 'AWSIoTTwinMaker',
      },
      {
        label: 'AWS Key Management Service (KMS)',
        value: 'AWSKeyManagementServiceKMS',
      },
      {
        label: 'AWS Lake Formation',
        value: 'AWSLakeFormation',
      },
      {
        label: 'AWS Lambda',
        value: 'AWSLambda',
      },
      {
        label: 'AWS Lambda Managed Instances',
        value: 'AWSLambdaManagedInstances',
      },
      {
        label: 'AWS License Manager',
        value: 'AWSLicenseManager',
      },
      {
        label: 'AWS Local Zones',
        value: 'AWSLocalZones',
      },
      {
        label: 'AWS Mainframe Modernization Blu Age',
        value: 'AWSMainframeModernizationBluAge',
      },
      {
        label: 'AWS Mainframe Modernization File Transfer BMC',
        value: 'AWSMainframeModernizationFileTransferBMC',
      },
      {
        label: 'AWS Mainframe Modernization Micro Focus',
        value: 'AWSMainframeModernizationMicroFocus',
      },
      {
        label: 'AWS Mainframe Modernization Precisely for IBM i',
        value: 'AWSMainframeModernizationPreciselyforIBMi',
      },
      {
        label: 'AWS Mainframe Modernization Precisely for IBM z/OS',
        value: 'AWSMainframeModernizationPreciselyforIBMzOS',
      },
      {
        label: 'AWS Mainframe Modernization Replatform NTT DATA UniKix',
        value: 'AWSMainframeModernizationReplatformNTTDATAUniKix',
      },
      {
        label: 'AWS Mainframe Modernization SPARC Stromasys',
        value: 'AWSMainframeModernizationSPARCStromasys',
      },
      {
        label: 'AWS Managed Services Accelerate',
        value: 'AWSManagedServicesAccelerate',
      },
      {
        label: 'AWS Managed Services Advanced',
        value: 'AWSManagedServicesAdvanced',
      },
      {
        label: 'AWS Managed Services Operations on Demand (OOD)',
        value: 'AWSManagedServicesOperationsonDemandOOD',
      },
      {
        label: 'AWS Marketplace - AMI',
        value: 'AWSMarketplaceAMI',
      },
      {
        label: 'AWS Marketplace - EC2',
        value: 'AWSMarketplaceEC2',
      },
      {
        label: 'AWS Marketplace - Professional Services',
        value: 'AWSMarketplaceProfessionalServices',
      },
      {
        label: 'AWS Marketplace - Saas',
        value: 'AWSMarketplaceSaas',
      },
      {
        label: 'AWS Migration Hub',
        value: 'AWSMigrationHub',
      },
      {
        label: 'AWS Migration Hub Refactor Spaces',
        value: 'AWSMigrationHubRefactorSpaces',
      },
      {
        label: 'AWS Migration Hub Strategy Recommendations',
        value: 'AWSMigrationHubStrategyRecommendations',
      },
      {
        label: 'AWS Mission Networking Dedicated Circuit',
        value: 'AWSMissionNetworkingDedicatedCircuit',
      },
      {
        label: 'AWS Mission Networking IP Tunnel',
        value: 'AWSMissionNetworkingIPTunnel',
      },
      {
        label: 'AWS Modular Data Center',
        value: 'AWSModularDataCenter',
      },
      {
        label: 'AWS Network Firewall',
        value: 'AWSNetworkFirewall',
      },
      {
        label: 'AWS Neuron',
        value: 'AWSNeuron',
      },
      {
        label: 'AWS OpsHub',
        value: 'AWSOpsHub',
      },
      {
        label: 'AWS OpsWorks',
        value: 'AWSOpsWorks',
      },
      {
        label: 'AWS Outposts',
        value: 'AWSOutposts',
      },
      {
        label: 'AWS Outposts Servers',
        value: 'AWSOutpostsServers',
      },
      {
        label: 'AWS ParallelCluster',
        value: 'AWSParallelCluster',
      },
      {
        label: 'AWS Parallel Computing Service',
        value: 'AWSParallelComputingService',
      },
      {
        label: 'AWS Partner Device Catalog',
        value: 'AWSPartnerDeviceCatalog',
      },
      {
        label: 'AWS Partner-Led Support',
        value: 'AWSPartnerLedSupport',
      },
      {
        label: 'AWS Payment Cryptography',
        value: 'AWSPaymentCryptography',
      },
      {
        label: 'AWS Private CA',
        value: 'AWSPrivateCA',
      },
      {
        label: 'AWS PrivateLink',
        value: 'AWSPrivateLink',
      },
      {
        label: 'AWS Program Management Office',
        value: 'AWSProgramManagementOffice',
      },
      {
        label: 'AWS RTB Fabric',
        value: 'AWSRTBFabric',
      },
      {
        label: 'AWS Resilience Hub',
        value: 'AWSResilienceHub',
      },
      {
        label: 'AWS RoboMaker',
        value: 'AWSRoboMaker',
      },
      {
        label: 'AWS SDKs and Tools',
        value: 'AWSSDKsandTools',
      },
      {
        label: 'AWS Secrets Manager',
        value: 'AWSSecretsManager',
      },
      {
        label: 'AWS Security Agent',
        value: 'AWSSecurityAgent',
      },
      {
        label: 'AWS Security Hub',
        value: 'AWSSecurityHub',
      },
      {
        label: 'AWS Security Incident Response',
        value: 'AWSSecurityIncidentResponse',
      },
      {
        label: 'AWS Serverless Application Repository',
        value: 'AWSServerlessApplicationRepository',
      },
      {
        label: 'AWS Service Catalog',
        value: 'AWSServiceCatalog',
      },
      {
        label: 'AWS Shield',
        value: 'AWSShield',
      },
      {
        label: 'AWS Shield network security director',
        value: 'AWSShieldnetworksecuritydirector',
      },
      {
        label: 'AWS SimSpace Weaver',
        value: 'AWSSimSpaceWeaver',
      },
      {
        label: 'AWS Single Sign-On',
        value: 'AWSSingleSignOn',
      },
      {
        label: 'AWS SiteLink',
        value: 'AWSSiteLink',
      },
      {
        label: 'AWS Site-to-Site VPN',
        value: 'AWSSitetoSiteVPN',
      },
      {
        label: 'AWS Snowmobile',
        value: 'AWSSnowmobile',
      },
      {
        label: 'AWS Step Functions',
        value: 'AWSStepFunctions',
      },
      {
        label: 'AWS Storage Gateway (S3 File Gateway)',
        value: 'AWSStorageGatewayS3FileGateway',
      },
      {
        label: 'AWS Storage Gateway (Tape Gateway)',
        value: 'AWSStorageGatewayTapeGateway',
      },
      {
        label: 'AWS Storage Gateway (Volume Gateway)',
        value: 'AWSStorageGatewayVolumeGateway',
      },
      {
        label: 'AWS Supply Chain',
        value: 'AWSSupplyChain',
      },
      {
        label: 'AWS Supply Chain Demand Planning',
        value: 'AWSSupplyChainDemandPlanning',
      },
      {
        label: 'AWS Supply Chain - Insights',
        value: 'AWSSupplyChainInsights',
      },
      {
        label: 'AWS Supply Chain - N-tier Visibility',
        value: 'AWSSupplyChainNtierVisibility',
      },
      {
        label: 'AWS Supply Chain - Supply Planning',
        value: 'AWSSupplyChainSupplyPlanning',
      },
      {
        label: 'AWS Supply Chain - Sustainability',
        value: 'AWSSupplyChainSustainability',
      },
      {
        label: 'AWS Systems Manager',
        value: 'AWSSystemsManager',
      },
      {
        label: 'AWS Systems Manager Fleet Manager',
        value: 'AWSSystemsManagerFleetManager',
      },
      {
        label: 'AWS Systems Manager Incident Manager',
        value: 'AWSSystemsManagerIncidentManager',
      },
      {
        label: 'AWS Transfer Family (SFTP, FTPS, FTP)',
        value: 'AWSTransferFamilySFTPFTPSFTP',
      },
      {
        label: 'AWS Transform Custom',
        value: 'AWSTransformCustom',
      },
      {
        label: 'AWS Transform for .NET',
        value: 'AWSTransformforNET',
      },
      {
        label: 'AWS Transform for SQL',
        value: 'AWSTransformforSQL',
      },
      {
        label: 'AWS Transform for VMware',
        value: 'AWSTransformforVMware',
      },
      {
        label: 'AWS Transform for mainframe',
        value: 'AWSTransformformainframe',
      },
      {
        label: 'AWS Transit Gateway',
        value: 'AWSTransitGateway',
      },
      {
        label: 'AWS Unified Operations',
        value: 'AWSUnifiedOperations',
      },
      {
        label: 'AWS Verified Access',
        value: 'AWSVerifiedAccess',
      },
      {
        label: 'AWS WAF - Web Application Firewall',
        value: 'AWSWAFWebApplicationFirewall',
      },
      {
        label: 'AWS Wavelength',
        value: 'AWSWavelength',
      },
      {
        label: 'AWS Well-Architected Tool',
        value: 'AWSWellArchitectedTool',
      },
      {
        label: 'AWS X-Ray',
        value: 'AWSXRay',
      },
      {
        label: 'AWS re:Post Private',
        value: 'AWSrePostPrivate',
      },
      {
        label: 'AgentCore',
        value: 'AgentCore',
      },
      {
        label: 'AgentCore Browser',
        value: 'AgentCoreBrowser',
      },
      {
        label: 'AgentCore Code Interpreter',
        value: 'AgentCoreCodeInterpreter',
      },
      {
        label: 'AgentCore Evaluations',
        value: 'AgentCoreEvaluations',
      },
      {
        label: 'AgentCore Gateway',
        value: 'AgentCoreGateway',
      },
      {
        label: 'AgentCore Identity',
        value: 'AgentCoreIdentity',
      },
      {
        label: 'AgentCore Memory',
        value: 'AgentCoreMemory',
      },
      {
        label: 'AgentCore Observability',
        value: 'AgentCoreObservability',
      },
      {
        label: 'AgentCore Policy',
        value: 'AgentCorePolicy',
      },
      {
        label: 'AgentCore Runtime',
        value: 'AgentCoreRuntime',
      },
      {
        label: 'AgentCore payments',
        value: 'AgentCorepayments',
      },
      {
        label: 'Alexa for Business',
        value: 'AlexaforBusiness',
      },
      {
        label: 'Amazon API Gateway',
        value: 'AmazonAPIGateway',
      },
      {
        label: 'Amazon AppFlow',
        value: 'AmazonAppFlow',
      },
      {
        label: 'Amazon AppStream 2.0',
        value: 'AmazonAppStream20',
      },
      {
        label: 'Amazon Athena',
        value: 'AmazonAthena',
      },
      {
        label: 'Amazon Augmented AI (A2I)',
        value: 'AmazonAugmentedAIA2I',
      },
      {
        label: 'Amazon Aurora DSQL',
        value: 'AmazonAuroraDSQL',
      },
      {
        label: 'Amazon Bedrock',
        value: 'AmazonBedrock',
      },
      {
        label: 'Amazon Bedrock - AI21 Labs Models',
        value: 'AmazonBedrockAI21LabsModels',
      },
      {
        label: 'Amazon Bedrock - Amazon Models',
        value: 'AmazonBedrockAmazonModels',
      },
      {
        label: 'Amazon Bedrock - Anthropic Claude Code',
        value: 'AmazonBedrockAnthropicClaudeCode',
      },
      {
        label: 'Amazon Bedrock - Anthropic Models',
        value: 'AmazonBedrockAnthropicModels',
      },
      {
        label: 'Amazon Bedrock - Cohere Models',
        value: 'AmazonBedrockCohereModels',
      },
      {
        label: 'Amazon Bedrock - Data Automation Audio',
        value: 'AmazonBedrockDataAutomationAudio',
      },
      {
        label: 'Amazon Bedrock - Data Automation Documents',
        value: 'AmazonBedrockDataAutomationDocuments',
      },
      {
        label: 'Amazon Bedrock - Data Automation Images',
        value: 'AmazonBedrockDataAutomationImages',
      },
      {
        label: 'Amazon Bedrock - Data Automation Video',
        value: 'AmazonBedrockDataAutomationVideo',
      },
      {
        label: 'Amazon Bedrock - DeepSeek Models',
        value: 'AmazonBedrockDeepSeekModels',
      },
      {
        label: 'Amazon Bedrock - Google Models',
        value: 'AmazonBedrockGoogleModels',
      },
      {
        label: 'Amazon Bedrock – Grok Models',
        value: 'AmazonBedrockGrokModels',
      },
      {
        label: 'Amazon Bedrock - Guardrails',
        value: 'AmazonBedrockGuardrails',
      },
      {
        label: 'Amazon Bedrock - Knowledge Bases',
        value: 'AmazonBedrockKnowledgeBases',
      },
      {
        label: 'Amazon Bedrock - Luma AI Models',
        value: 'AmazonBedrockLumaAIModels',
      },
      {
        label: 'Amazon Bedrock - Managed Agents',
        value: 'AmazonBedrockManagedAgents',
      },
      {
        label: 'Amazon Bedrock - Meta Models',
        value: 'AmazonBedrockMetaModels',
      },
      {
        label: 'Amazon Bedrock - MiniMax AI Models',
        value: 'AmazonBedrockMiniMaxAIModels',
      },
      {
        label: 'Amazon Bedrock - Mistral AI Models',
        value: 'AmazonBedrockMistralAIModels',
      },
      {
        label: 'Amazon Bedrock - Moonshot AI Models',
        value: 'AmazonBedrockMoonshotAIModels',
      },
      {
        label: 'Amazon Bedrock - NVIDIA Models',
        value: 'AmazonBedrockNVIDIAModels',
      },
      {
        label: 'Amazon Bedrock - OpenAI Codex',
        value: 'AmazonBedrockOpenAICodex',
      },
      {
        label: 'Amazon Bedrock - OpenAI Models',
        value: 'AmazonBedrockOpenAIModels',
      },
      {
        label: 'Amazon Bedrock - Qwen Models',
        value: 'AmazonBedrockQwenModels',
      },
      {
        label: 'Amazon Bedrock - Stability AI Models',
        value: 'AmazonBedrockStabilityAIModels',
      },
      {
        label: 'Amazon Bedrock - TwelveLabs Models',
        value: 'AmazonBedrockTwelveLabsModels',
      },
      {
        label: 'Amazon Bedrock - Undisclosed Model Provider',
        value: 'AmazonBedrockUndisclosedModelProvider',
      },
      {
        label: 'Amazon Bedrock - Writer Models',
        value: 'AmazonBedrockWriterModels',
      },
      {
        label: 'Amazon Bedrock - poolside Models',
        value: 'AmazonBedrockpoolsideModels',
      },
      {
        label: 'Amazon Bio Discovery',
        value: 'AmazonBioDiscovery',
      },
      {
        label: 'Amazon Braket',
        value: 'AmazonBraket',
      },
      {
        label: 'Amazon Chime SDK',
        value: 'AmazonChimeSDK',
      },
      {
        label: 'Amazon Chime Voice Connector',
        value: 'AmazonChimeVoiceConnector',
      },
      {
        label: 'Amazon CloudFront',
        value: 'AmazonCloudFront',
      },
      {
        label: 'Amazon CloudSearch',
        value: 'AmazonCloudSearch',
      },
      {
        label: 'Amazon CloudWatch',
        value: 'AmazonCloudWatch',
      },
      {
        label: 'Amazon CloudWatch Application Insights',
        value: 'AmazonCloudWatchApplicationInsights',
      },
      {
        label: 'Amazon CloudWatch Evidently',
        value: 'AmazonCloudWatchEvidently',
      },
      {
        label: 'Amazon CloudWatch RUM',
        value: 'AmazonCloudWatchRUM',
      },
      {
        label: 'Amazon CloudWatch Synthetics',
        value: 'AmazonCloudWatchSynthetics',
      },
      {
        label: 'Amazon CodeCatalyst',
        value: 'AmazonCodeCatalyst',
      },
      {
        label: 'Amazon CodeGuru Profiler',
        value: 'AmazonCodeGuruProfiler',
      },
      {
        label: 'Amazon CodeGuru Security',
        value: 'AmazonCodeGuruSecurity',
      },
      {
        label: 'Amazon Cognito',
        value: 'AmazonCognito',
      },
      {
        label: 'Amazon Comprehend',
        value: 'AmazonComprehend',
      },
      {
        label: 'Amazon Comprehend Medical',
        value: 'AmazonComprehendMedical',
      },
      {
        label: 'Amazon Connect AI Agents',
        value: 'AmazonConnectAIAgents',
      },
      {
        label: 'Amazon Connect - Apple Messages for Business',
        value: 'AmazonConnectAppleMessagesforBusiness',
      },
      {
        label: 'Amazon Connect - Cases',
        value: 'AmazonConnectCases',
      },
      {
        label: 'Amazon Connect - Chat',
        value: 'AmazonConnectChat',
      },
      {
        label: 'Amazon Connect Contact Lens for external voice',
        value: 'AmazonConnectContactLensforexternalvoice',
      },
      {
        label: 'Amazon Connect - Customer Profiles',
        value: 'AmazonConnectCustomerProfiles',
      },
      {
        label: 'Amazon Connect Decisions',
        value: 'AmazonConnectDecisions',
      },
      {
        label: 'Amazon Connect - Email',
        value: 'AmazonConnectEmail',
      },
      {
        label: 'Amazon Connect - External Voice Transfers',
        value: 'AmazonConnectExternalVoiceTransfers',
      },
      {
        label: 'Amazon Connect - Forecast Plan Schedule',
        value: 'AmazonConnectForecastPlanSchedule',
      },
      {
        label: 'Amazon Connect - Global Resiliency',
        value: 'AmazonConnectGlobalResiliency',
      },
      {
        label: 'Amazon Connect Guides',
        value: 'AmazonConnectGuides',
      },
      {
        label: 'Amazon Connect Health - Patient Engagement',
        value: 'AmazonConnectHealthPatientEngagement',
      },
      {
        label: 'Amazon Connect Health - Point of Care',
        value: 'AmazonConnectHealthPointofCare',
      },
      {
        label: 'Amazon Connect - High-Volume Outbound Communications',
        value: 'AmazonConnectHighVolumeOutboundCommunications',
      },
      {
        label: 'Amazon Connect - IVR',
        value: 'AmazonConnectIVR',
      },
      {
        label: 'Amazon Connect In-app and web calling',
        value: 'AmazonConnectInappandwebcalling',
      },
      {
        label: 'Amazon Connect - Outbound Campaigns',
        value: 'AmazonConnectOutboundCampaigns',
      },
      {
        label: 'Amazon Connect - Performance Evaluation',
        value: 'AmazonConnectPerformanceEvaluation',
      },
      {
        label: 'Amazon Connect - SMS',
        value: 'AmazonConnectSMS',
      },
      {
        label: 'Amazon Connect - Screen Recording',
        value: 'AmazonConnectScreenRecording',
      },
      {
        label: 'Amazon Connect - Talent',
        value: 'AmazonConnectTalent',
      },
      {
        label: 'Amazon Connect - Tasks',
        value: 'AmazonConnectTasks',
      },
      {
        label: 'Amazon Connect - Telephony',
        value: 'AmazonConnectTelephony',
      },
      {
        label: 'Amazon Connect - Unlimited AI Chat',
        value: 'AmazonConnectUnlimitedAIChat',
      },
      {
        label: 'Amazon Connect - Unlimited AI Email',
        value: 'AmazonConnectUnlimitedAIEmail',
      },
      {
        label: 'Amazon Connect - Unlimited AI Messaging',
        value: 'AmazonConnectUnlimitedAIMessaging',
      },
      {
        label: 'Amazon Connect - Unlimited AI Voice',
        value: 'AmazonConnectUnlimitedAIVoice',
      },
      {
        label: 'Amazon Connect Video calling',
        value: 'AmazonConnectVideocalling',
      },
      {
        label: 'Amazon Connect - Voice',
        value: 'AmazonConnectVoice',
      },
      {
        label: 'Amazon Connect for WhatsApp Business Messaging',
        value: 'AmazonConnectforWhatsAppBusinessMessaging',
      },
      {
        label: 'Amazon Data Firehose',
        value: 'AmazonDataFirehose',
      },
      {
        label: 'Amazon DataZone',
        value: 'AmazonDataZone',
      },
      {
        label: 'Amazon Database Migration Accelerator',
        value: 'AmazonDatabaseMigrationAccelerator',
      },
      {
        label: 'Amazon Detective',
        value: 'AmazonDetective',
      },
      {
        label: 'Amazon DevOps Guru',
        value: 'AmazonDevOpsGuru',
      },
      {
        label: 'Amazon DocumentDB',
        value: 'AmazonDocumentDB',
      },
      {
        label: 'Amazon DynamoDB',
        value: 'AmazonDynamoDB',
      },
      {
        label: 'Amazon EC2 Auto Scaling',
        value: 'AmazonEC2AutoScaling',
      },
      {
        label: 'Amazon EC2 - C5n',
        value: 'AmazonEC2C5n',
      },
      {
        label: 'Amazon EC2 - DL1',
        value: 'AmazonEC2DL1',
      },
      {
        label: 'Amazon EC2 - F1',
        value: 'AmazonEC2F1',
      },
      {
        label: 'Amazon EC2 - F2',
        value: 'AmazonEC2F2',
      },
      {
        label: 'Amazon EC2 - G4',
        value: 'AmazonEC2G4',
      },
      {
        label: 'Amazon EC2 - G5',
        value: 'AmazonEC2G5',
      },
      {
        label: 'Amazon EC2 - G6',
        value: 'AmazonEC2G6',
      },
      {
        label: 'Amazon EC2 - G6e',
        value: 'AmazonEC2G6e',
      },
      {
        label: 'Amazon EC2 - G7e',
        value: 'AmazonEC2G7e',
      },
      {
        label: 'Amazon EC2 - Graviton',
        value: 'AmazonEC2Graviton',
      },
      {
        label: 'Amazon EC2 - HPC6a',
        value: 'AmazonEC2HPC6a',
      },
      {
        label: 'Amazon EC2 - HPC6id',
        value: 'AmazonEC2HPC6id',
      },
      {
        label: 'Amazon EC2 - HPC7a',
        value: 'AmazonEC2HPC7a',
      },
      {
        label: 'Amazon EC2 - HPC7g',
        value: 'AmazonEC2HPC7g',
      },
      {
        label: 'Amazon EC2 - HPC8a',
        value: 'AmazonEC2HPC8a',
      },
      {
        label: 'Amazon EC2 - Inf1',
        value: 'AmazonEC2Inf1',
      },
      {
        label: 'Amazon EC2 - Inf2',
        value: 'AmazonEC2Inf2',
      },
      {
        label: 'Amazon EC2 Linux',
        value: 'AmazonEC2Linux',
      },
      {
        label: 'Amazon EC2 - Mac',
        value: 'AmazonEC2Mac',
      },
      {
        label: 'Amazon EC2 - P3dn',
        value: 'AmazonEC2P3dn',
      },
      {
        label: 'Amazon EC2 - P4d',
        value: 'AmazonEC2P4d',
      },
      {
        label: 'Amazon EC2 - P4de',
        value: 'AmazonEC2P4de',
      },
      {
        label: 'Amazon EC2 - P5',
        value: 'AmazonEC2P5',
      },
      {
        label: 'Amazon EC2 - P5e',
        value: 'AmazonEC2P5e',
      },
      {
        label: 'Amazon EC2 - P5en',
        value: 'AmazonEC2P5en',
      },
      {
        label: 'Amazon EC2 P6-B200',
        value: 'AmazonEC2P6B200',
      },
      {
        label: 'Amazon EC2 P6-B300',
        value: 'AmazonEC2P6B300',
      },
      {
        label: 'Amazon EC2 P6e-GB200',
        value: 'AmazonEC2P6eGB200',
      },
      {
        label: 'Amazon EC2 P6e-GB300',
        value: 'AmazonEC2P6eGB300',
      },
      {
        label: 'Amazon EC2 - RHEL',
        value: 'AmazonEC2RHEL',
      },
      {
        label: 'Amazon EC2 Spot',
        value: 'AmazonEC2Spot',
      },
      {
        label: 'Amazon EC2 - Trn1',
        value: 'AmazonEC2Trn1',
      },
      {
        label: 'Amazon EC2 - Trn2',
        value: 'AmazonEC2Trn2',
      },
      {
        label: 'Amazon EC2 - Trn3',
        value: 'AmazonEC2Trn3',
      },
      {
        label: 'Amazon EC2 - VT1',
        value: 'AmazonEC2VT1',
      },
      {
        label: 'Amazon EC2 Windows',
        value: 'AmazonEC2Windows',
      },
      {
        label: 'Amazon EC2 Windows-BYOL',
        value: 'AmazonEC2WindowsBYOL',
      },
      {
        label: 'Amazon ECS Anywhere',
        value: 'AmazonECSAnywhere',
      },
      {
        label: 'Amazon ECS Managed Instances',
        value: 'AmazonECSManagedInstances',
      },
      {
        label: 'Amazon ECS on AWS Fargate',
        value: 'AmazonECSonAWSFargate',
      },
      {
        label: 'Amazon EKS Anywhere',
        value: 'AmazonEKSAnywhere',
      },
      {
        label: 'Amazon EKS Auto Mode',
        value: 'AmazonEKSAutoMode',
      },
      {
        label: 'Amazon EKS Hybrid Nodes',
        value: 'AmazonEKSHybridNodes',
      },
      {
        label: 'Amazon EKS on AWS Fargate',
        value: 'AmazonEKSonAWSFargate',
      },
      {
        label: 'Amazon EKS on Outpost',
        value: 'AmazonEKSonOutpost',
      },
      {
        label: 'Amazon EVS Windows Server Licensing',
        value: 'AmazonEVSWindowsServerLicensing',
      },
      {
        label: 'Amazon ElastiCache',
        value: 'AmazonElastiCache',
      },
      {
        label: 'Amazon Elastic Block Store (EBS)',
        value: 'AmazonElasticBlockStoreEBS',
      },
      {
        label: 'Amazon Elastic Container Registry (ECR)',
        value: 'AmazonElasticContainerRegistryECR',
      },
      {
        label: 'Amazon Elastic Container Service (ECS)',
        value: 'AmazonElasticContainerServiceECS',
      },
      {
        label: 'Amazon Elastic File System (EFS)',
        value: 'AmazonElasticFileSystemEFS',
      },
      {
        label: 'Amazon Elastic Inference',
        value: 'AmazonElasticInference',
      },
      {
        label: 'Amazon Elastic Kubernetes Service (EKS)',
        value: 'AmazonElasticKubernetesServiceEKS',
      },
      {
        label: 'Amazon Elastic MapReduce (EMR)',
        value: 'AmazonElasticMapReduceEMR',
      },
      {
        label: 'Amazon Elastic Transcoder',
        value: 'AmazonElasticTranscoder',
      },
      {
        label: 'Amazon Elastic VMware Service (Amazon EVS)',
        value: 'AmazonElasticVMwareServiceAmazonEVS',
      },
      {
        label: 'Amazon EventBridge',
        value: 'AmazonEventBridge',
      },
      {
        label: 'Amazon FSx for Lustre',
        value: 'AmazonFSxforLustre',
      },
      {
        label: 'Amazon FSx for NetApp ONTAP',
        value: 'AmazonFSxforNetAppONTAP',
      },
      {
        label: 'Amazon FSx for OpenZFS',
        value: 'AmazonFSxforOpenZFS',
      },
      {
        label: 'Amazon FSx for Windows File Server',
        value: 'AmazonFSxforWindowsFileServer',
      },
      {
        label: 'Amazon File Cache',
        value: 'AmazonFileCache',
      },
      {
        label: 'Amazon FinSpace',
        value: 'AmazonFinSpace',
      },
      {
        label: 'Amazon Forecast',
        value: 'AmazonForecast',
      },
      {
        label: 'Amazon Fraud Detector',
        value: 'AmazonFraudDetector',
      },
      {
        label: 'Amazon GameLift Servers',
        value: 'AmazonGameLiftServers',
      },
      {
        label: 'Amazon GameLift Servers FleetIQ',
        value: 'AmazonGameLiftServersFleetIQ',
      },
      {
        label: 'Amazon GameLift Servers FlexMatch',
        value: 'AmazonGameLiftServersFlexMatch',
      },
      {
        label: 'Amazon GameLift Streams',
        value: 'AmazonGameLiftStreams',
      },
      {
        label: 'Amazon GameSparks',
        value: 'AmazonGameSparks',
      },
      {
        label: 'Amazon GuardDuty',
        value: 'AmazonGuardDuty',
      },
      {
        label: 'Amazon HealthLake',
        value: 'AmazonHealthLake',
      },
      {
        label: 'Amazon Honeycode',
        value: 'AmazonHoneycode',
      },
      {
        label: 'Amazon IVS Chat',
        value: 'AmazonIVSChat',
      },
      {
        label: 'Amazon Inspector',
        value: 'AmazonInspector',
      },
      {
        label: 'Amazon Interactive Video Service',
        value: 'AmazonInteractiveVideoService',
      },
      {
        label: 'Amazon Kendra',
        value: 'AmazonKendra',
      },
      {
        label: 'Amazon Keyspaces',
        value: 'AmazonKeyspaces',
      },
      {
        label: 'Amazon Kinesis Data Streams (KDS)',
        value: 'AmazonKinesisDataStreamsKDS',
      },
      {
        label: 'Amazon Kinesis Video Streams',
        value: 'AmazonKinesisVideoStreams',
      },
      {
        label: 'Amazon Lex',
        value: 'AmazonLex',
      },
      {
        label: 'Amazon Lex with Amazon Connect',
        value: 'AmazonLexwithAmazonConnect',
      },
      {
        label: 'Amazon Libra',
        value: 'AmazonLibra',
      },
      {
        label: 'Amazon Lightsail',
        value: 'AmazonLightsail',
      },
      {
        label: 'Amazon Location Service',
        value: 'AmazonLocationService',
      },
      {
        label: 'Amazon Lookout for Equipment',
        value: 'AmazonLookoutforEquipment',
      },
      {
        label: 'Amazon Lookout for Metrics',
        value: 'AmazonLookoutforMetrics',
      },
      {
        label: 'Amazon Lookout for Vision',
        value: 'AmazonLookoutforVision',
      },
      {
        label: 'Amazon Lumberyard',
        value: 'AmazonLumberyard',
      },
      {
        label: 'Amazon MQ for ActiveMQ',
        value: 'AmazonMQforActiveMQ',
      },
      {
        label: 'Amazon MQ for RabbitMQ',
        value: 'AmazonMQforRabbitMQ',
      },
      {
        label: 'Amazon Macie',
        value: 'AmazonMacie',
      },
      {
        label: 'Amazon Managed Blockchain',
        value: 'AmazonManagedBlockchain',
      },
      {
        label: 'Amazon Managed Grafana',
        value: 'AmazonManagedGrafana',
      },
      {
        label: 'Amazon Managed Service for Apache Flink',
        value: 'AmazonManagedServiceforApacheFlink',
      },
      {
        label: 'Amazon Managed Service for Prometheus',
        value: 'AmazonManagedServiceforPrometheus',
      },
      {
        label: 'Amazon Managed Streaming for Apache Kafka (MSK)',
        value: 'AmazonManagedStreamingforApacheKafkaMSK',
      },
      {
        label: 'Amazon Managed Workflows for Apache Airflow (MWAA)',
        value: 'AmazonManagedWorkflowsforApacheAirflowMWAA',
      },
      {
        label: 'Amazon Mechanical Turk (MTurk)',
        value: 'AmazonMechanicalTurkMTurk',
      },
      {
        label: 'Amazon MemoryDB',
        value: 'AmazonMemoryDB',
      },
      {
        label: 'Amazon Monitron',
        value: 'AmazonMonitron',
      },
      {
        label: 'Amazon Neptune',
        value: 'AmazonNeptune',
      },
      {
        label: 'Amazon Nimble Studio',
        value: 'AmazonNimbleStudio',
      },
      {
        label: 'Amazon Nova Act',
        value: 'AmazonNovaAct',
      },
      {
        label: 'Amazon Nova Forge',
        value: 'AmazonNovaForge',
      },
      {
        label: 'Amazon Omics',
        value: 'AmazonOmics',
      },
      {
        label: 'Amazon One',
        value: 'AmazonOne',
      },
      {
        label: 'Amazon OpenSearch for Search/vectors',
        value: 'AmazonOpenSearchforSearchvectors',
      },
      {
        label: 'Amazon OpenSearch for logs/Analytics',
        value: 'AmazonOpenSearchforlogsAnalytics',
      },
      {
        label: 'Amazon Personalize',
        value: 'AmazonPersonalize',
      },
      {
        label: 'Amazon Polly',
        value: 'AmazonPolly',
      },
      {
        label: 'Amazon Q Business',
        value: 'AmazonQBusiness',
      },
      {
        label: 'Amazon Q Developer',
        value: 'AmazonQDeveloper',
      },
      {
        label: 'Amazon Quantum Ledger Database (QLDB)',
        value: 'AmazonQuantumLedgerDatabaseQLDB',
      },
      {
        label: 'Amazon Quick',
        value: 'AmazonQuick',
      },
      {
        label: 'Amazon QuickSight',
        value: 'AmazonQuickSight',
      },
      {
        label: 'Amazon QuickSight Paginated Reports',
        value: 'AmazonQuickSightPaginatedReports',
      },
      {
        label: 'Amazon QuickSight Q',
        value: 'AmazonQuickSightQ',
      },
      {
        label: 'Amazon RDS Aurora for MySQL',
        value: 'AmazonRDSAuroraforMySQL',
      },
      {
        label: 'Amazon RDS Aurora for PostgreSQL',
        value: 'AmazonRDSAuroraforPostgreSQL',
      },
      {
        label: 'Amazon RDS Custom for SQL Server',
        value: 'AmazonRDSCustomforSQLServer',
      },
      {
        label: 'Amazon RDS Proxy',
        value: 'AmazonRDSProxy',
      },
      {
        label: 'Amazon RDS for Db2',
        value: 'AmazonRDSforDb2',
      },
      {
        label: 'Amazon RDS for MariaDB',
        value: 'AmazonRDSforMariaDB',
      },
      {
        label: 'Amazon RDS for MySQL',
        value: 'AmazonRDSforMySQL',
      },
      {
        label: 'Amazon RDS for Oracle',
        value: 'AmazonRDSforOracle',
      },
      {
        label: 'Amazon RDS for PostgreSQL',
        value: 'AmazonRDSforPostgreSQL',
      },
      {
        label: 'Amazon RDS for SQL Server',
        value: 'AmazonRDSforSQLServer',
      },
      {
        label: 'Amazon RDS on Outposts',
        value: 'AmazonRDSonOutposts',
      },
      {
        label: 'Amazon Redshift',
        value: 'AmazonRedshift',
      },
      {
        label: 'Amazon Rekognition Custom Labels',
        value: 'AmazonRekognitionCustomLabels',
      },
      {
        label: 'Amazon Rekognition Face Liveness',
        value: 'AmazonRekognitionFaceLiveness',
      },
      {
        label: 'Amazon Rekognition Image',
        value: 'AmazonRekognitionImage',
      },
      {
        label: 'Amazon Rekognition Video',
        value: 'AmazonRekognitionVideo',
      },
      {
        label: 'Amazon Route 53',
        value: 'AmazonRoute53',
      },
      {
        label: 'Amazon Route 53 Application Recovery Controller',
        value: 'AmazonRoute53ApplicationRecoveryController',
      },
      {
        label: 'Amazon S3',
        value: 'AmazonS3',
      },
      {
        label: 'Amazon S3 Glacier',
        value: 'AmazonS3Glacier',
      },
      {
        label: 'Amazon S3 Glacier Instant Retrieval',
        value: 'AmazonS3GlacierInstantRetrieval',
      },
      {
        label: 'Amazon S3 Tables',
        value: 'AmazonS3Tables',
      },
      {
        label: 'Amazon S3 Vectors',
        value: 'AmazonS3Vectors',
      },
      {
        label: 'Amazon SQS',
        value: 'AmazonSQS',
      },
      {
        label: 'Amazon SageMaker',
        value: 'AmazonSageMaker',
      },
      {
        label: 'Amazon SageMaker Autopilot',
        value: 'AmazonSageMakerAutopilot',
      },
      {
        label: 'Amazon SageMaker Canvas',
        value: 'AmazonSageMakerCanvas',
      },
      {
        label: 'Amazon SageMaker Catalog',
        value: 'AmazonSageMakerCatalog',
      },
      {
        label: 'Amazon SageMaker Data Wrangler',
        value: 'AmazonSageMakerDataWrangler',
      },
      {
        label: 'Amazon SageMaker Edge Manager',
        value: 'AmazonSageMakerEdgeManager',
      },
      {
        label: 'Amazon SageMaker Feature Store',
        value: 'AmazonSageMakerFeatureStore',
      },
      {
        label: 'Amazon SageMaker Ground Truth',
        value: 'AmazonSageMakerGroundTruth',
      },
      {
        label: 'Amazon SageMaker HyperPod',
        value: 'AmazonSageMakerHyperPod',
      },
      {
        label: 'Amazon SageMaker Inference',
        value: 'AmazonSageMakerInference',
      },
      {
        label: 'Amazon SageMaker JumpStart',
        value: 'AmazonSageMakerJumpStart',
      },
      {
        label: 'Amazon SageMaker Lakehouse',
        value: 'AmazonSageMakerLakehouse',
      },
      {
        label: 'Amazon SageMaker Managed MLFLow',
        value: 'AmazonSageMakerManagedMLFLow',
      },
      {
        label: 'Amazon SageMaker Notebook Instances',
        value: 'AmazonSageMakerNotebookInstances',
      },
      {
        label: 'Amazon SageMaker Processing',
        value: 'AmazonSageMakerProcessing',
      },
      {
        label: 'Amazon SageMaker Serverless Model Customization',
        value: 'AmazonSageMakerServerlessModelCustomization',
      },
      {
        label: 'Amazon SageMaker Studio',
        value: 'AmazonSageMakerStudio',
      },
      {
        label: 'Amazon SageMaker Training',
        value: 'AmazonSageMakerTraining',
      },
      {
        label: 'Amazon SageMaker Unified Studio',
        value: 'AmazonSageMakerUnifiedStudio',
      },
      {
        label: 'Amazon Sagemaker - Nova Customization',
        value: 'AmazonSagemakerNovaCustomization',
      },
      {
        label: 'Amazon Security Lake',
        value: 'AmazonSecurityLake',
      },
      {
        label: 'Amazon Simple Email Service (SES)',
        value: 'AmazonSimpleEmailServiceSES',
      },
      {
        label: 'Amazon Simple Notification Service (SNS) A2A',
        value: 'AmazonSimpleNotificationServiceSNSA2A',
      },
      {
        label: 'Amazon Simple Notification Service (SNS) A2P',
        value: 'AmazonSimpleNotificationServiceSNSA2P',
      },
      {
        label: 'Amazon Sumerian',
        value: 'AmazonSumerian',
      },
      {
        label: 'Amazon Textract',
        value: 'AmazonTextract',
      },
      {
        label: 'Amazon Transcribe',
        value: 'AmazonTranscribe',
      },
      {
        label: 'Amazon Transcribe Medical',
        value: 'AmazonTranscribeMedical',
      },
      {
        label: 'Amazon VPC Lattice',
        value: 'AmazonVPCLattice',
      },
      {
        label: 'Amazon Verified Permissions',
        value: 'AmazonVerifiedPermissions',
      },
      {
        label: 'Amazon Virtual Private Cloud (VPC)',
        value: 'AmazonVirtualPrivateCloudVPC',
      },
      {
        label: 'Amazon WorkDocs',
        value: 'AmazonWorkDocs',
      },
      {
        label: 'Amazon WorkLink',
        value: 'AmazonWorkLink',
      },
      {
        label: 'Amazon WorkMail',
        value: 'AmazonWorkMail',
      },
      {
        label: 'Amazon WorkSpaces Application Manager (WAM)',
        value: 'AmazonWorkSpacesApplicationManagerWAM',
      },
      {
        label: 'Amazon WorkSpaces Core',
        value: 'AmazonWorkSpacesCore',
      },
      {
        label: 'Amazon WorkSpaces Core Managed Instances',
        value: 'AmazonWorkSpacesCoreManagedInstances',
      },
      {
        label: 'Amazon WorkSpaces Pools',
        value: 'AmazonWorkSpacesPools',
      },
      {
        label: 'Amazon WorkSpaces Secure Browser',
        value: 'AmazonWorkSpacesSecureBrowser',
      },
      {
        label: 'Amazon WorkSpaces Thin Client',
        value: 'AmazonWorkSpacesThinClient',
      },
      {
        label: 'Amazon Workspaces',
        value: 'AmazonWorkspaces',
      },
      {
        label:
          'Amplify Admin UI import existing Cognito User Pool and Identity Pools',
        value: 'AmplifyAdminUIimportexistingCognitoUserPoolandIdentityPools',
      },
      {
        label: 'Apache MXNet on AWS',
        value: 'ApacheMXNetonAWS',
      },
      {
        label: 'Babelfish for Aurora PostgreSQL',
        value: 'BabelfishforAuroraPostgreSQL',
      },
      {
        label: 'Claude Enterprise in AWS Marketplace',
        value: 'ClaudeEnterpriseinAWSMarketplace',
      },
      {
        label: 'Claude Platform on AWS',
        value: 'ClaudePlatformonAWS',
      },
      {
        label: 'CloudEndure Disaster Recovery',
        value: 'CloudEndureDisasterRecovery',
      },
      {
        label: 'CloudEndure Migration',
        value: 'CloudEndureMigration',
      },
      {
        label: 'CloudTrail Lake',
        value: 'CloudTrailLake',
      },
      {
        label: 'CloudWatch Omni',
        value: 'CloudWatchOmni',
      },
      {
        label: 'CloudWatch Omni for Agents',
        value: 'CloudWatchOmniforAgents',
      },
      {
        label: 'Contact Lens for Amazon Connect',
        value: 'ContactLensforAmazonConnect',
      },
      {
        label: 'Cross-Region Data Transfer',
        value: 'CrossRegionDataTransfer',
      },
      {
        label: 'Elastic Fabric Adapter (EFA)',
        value: 'ElasticFabricAdapterEFA',
      },
      {
        label: 'Elastic Load Balancing (ELB)',
        value: 'ElasticLoadBalancingELB',
      },
      {
        label: 'FreeRTOS (IoT)',
        value: 'FreeRTOSIoT',
      },
      {
        label: 'Gateway Load Balancer',
        value: 'GatewayLoadBalancer',
      },
      {
        label: 'GitLab Duo with Amazon Q',
        value: 'GitLabDuowithAmazonQ',
      },
      {
        label: 'Kiro',
        value: 'Kiro',
      },
      {
        label: 'Migration Evaluator (TSO Logic)',
        value: 'MigrationEvaluatorTSOLogic',
      },
      {
        label: 'NICE DCV',
        value: 'NICEDCV',
      },
      {
        label: 'Oracle Database@AWS',
        value: 'OracleDatabaseAWS',
      },
      {
        label: 'Oracle on AWS- General',
        value: 'OracleonAWSGeneral',
      },
      {
        label: 'Porting Assistant for .NET',
        value: 'PortingAssistantforNET',
      },
      {
        label: 'Red Hat OpenShift Service on AWS (ROSA)',
        value: 'RedHatOpenShiftServiceonAWSROSA',
      },
      {
        label: 'Research and Engineering Studio (RES)',
        value: 'ResearchandEngineeringStudioRES',
      },
      {
        label: 'Route 53 Resolver DNS Firewall',
        value: 'Route53ResolverDNSFirewall',
      },
      {
        label: 'S3 Express One Zone',
        value: 'S3ExpressOneZone',
      },
      {
        label: 'S3 Files',
        value: 'S3Files',
      },
      {
        label: 'S3 Glacier Deep Archive',
        value: 'S3GlacierDeepArchive',
      },
      {
        label: 'S3 Intelligent-Tiering',
        value: 'S3IntelligentTiering',
      },
      {
        label: 'SAP on AWS – BDC',
        value: 'SAPonAWSBDC',
      },
      {
        label: 'SAP on AWS – BTP',
        value: 'SAPonAWSBTP',
      },
      {
        label: 'SAP on AWS – GROW',
        value: 'SAPonAWSGROW',
      },
      {
        label: 'SAP on AWS - General',
        value: 'SAPonAWSGeneral',
      },
      {
        label: 'SAP on AWS – LOB',
        value: 'SAPonAWSLOB',
      },
      {
        label: 'Security Hub Extended',
        value: 'SecurityHubExtended',
      },
      {
        label: 'Snowball - Data Transfer',
        value: 'SnowballDataTransfer',
      },
      {
        label: 'Snowball - Edge Compute',
        value: 'SnowballEdgeCompute',
      },
      {
        label: 'Snowball with Tape Gateway',
        value: 'SnowballwithTapeGateway',
      },
      {
        label: 'Snowcone - Data Transfer',
        value: 'SnowconeDataTransfer',
      },
      {
        label: 'Snowcone - Edge Compute',
        value: 'SnowconeEdgeCompute',
      },
      {
        label: 'Timestream for InfluxDB',
        value: 'TimestreamforInfluxDB',
      },
      {
        label: 'VMWare Managed Cloud on AWS',
        value: 'VMWareManagedCloudonAWS',
      },
      {
        label: 'VMware Cloud on AWS',
        value: 'VMwareCloudonAWS',
      },
      {
        label: 'VMware Cloud on AWS Outposts',
        value: 'VMwareCloudonAWSOutposts',
      },
      {
        label: 'Wickr',
        value: 'Wickr',
      },
    ],
  },
  {
    title: 'Sender Company Name',
    placeHolder: '',
    id: 'senderCompanyName',
    isRequired: false,
    humanReadableKey: 'Labra__Sender_Company_Name__c',
    isReadOnly: true,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Sender Company Domain',
    placeHolder: '',
    id: 'senderCompanyDomain',
    isRequired: false,
    humanReadableKey: 'Labra__Sender_Company_Domain__c',
    isReadOnly: true,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Sender Contact Email',
    placeHolder: '',
    id: 'senderContactEmail',
    isRequired: false,
    humanReadableKey: 'Labra__Sender_Contact_Email__c',
    isReadOnly: true,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Sender Contact First Name',
    placeHolder: '',
    id: 'senderContactFirstName',
    isRequired: false,
    humanReadableKey: 'Labra__Sender_Contact_First_Name__c',
    isReadOnly: true,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Sender Contact Last Name',
    placeHolder: '',
    id: 'senderContactLastName',
    isRequired: false,
    humanReadableKey: 'Labra__Sender_Contact_Last_Name__c',
    isReadOnly: true,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Customer AWS account ID (Optional)',
    placeHolder: '',
    id: 'awsAccountId',
    isRequired: false,
    humanReadableKey: 'Labra__AWS_Account_Id__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
    maxLength: 12,
  },
  {
    title: 'Offer ID (Optional)',
    placeHolder: '',
    id: 'offerId',
    isRequired: false,
    humanReadableKey: 'Labra__Offer_ID__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Competitive tracking (Optional)',
    placeHolder: '',
    id: 'competitiveTracking',
    isRequired: false,
    humanReadableKey: 'Labra__Competitive_Tracking__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: competitiveTrackingOptions,
  },
  {
    title: 'Competitive tracking other (Optional)',
    placeHolder: '',
    id: 'competitiveTrackingOther',
    isRequired: false,
    humanReadableKey: 'Labra__Other_Competitive_Tracking__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
]

export const referralMarketingDetailsFields: Array<FieldUI & FormField> = [
  {
    title: 'Is From Marketing Activity?',
    placeHolder: 'Is From Marketing Activity?',
    id: 'isThisFromMarketing',
    isRequired: true,
    humanReadableKey: 'Labra__IsOppFromMarketingActivity__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: ['Yes', 'No'],
  },
  {
    title: 'Was MDF Used? (Optional)',
    placeHolder: 'Was MDF Used?',
    id: 'marketingFundsUsed',
    isRequired: false,
    humanReadableKey: 'Labra__MDF_Needed__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: ['Yes', 'No'],
  },
  {
    title: 'Marketing activity channel (Optional)',
    placeHolder: '',
    id: 'marketingActivityChannel',
    isRequired: false,
    humanReadableKey: 'Labra__marketingActivityChannel__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'multi_enum',
    options: marketingActivityChannelOptions,
    columns: 12,
  },
  {
    title: 'Marketing activity use case (Optional)',
    placeHolder: '',
    id: 'marketingActivityUseCase',
    isRequired: false,
    humanReadableKey: 'Labra__marketingActivityUsecase__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'multi_enum',
    options: marketingActivityUseCaseOptions,
    columns: 12,
  },
  {
    title: 'Marketing campaign code (Optional)',
    placeHolder: '',
    id: 'marketingCampaignCode',
    isRequired: false,
    humanReadableKey: 'Labra__awsSFCampaignName__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
]

export const projectDetailsFields: Array<FieldUI & FormField> = [
  {
    title: 'Partner project title',
    placeHolder: '',
    id: 'partnerProjectTitle',
    isRequired: true,
    humanReadableKey: 'Name',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
    columns: 12,
  },
  {
    title: 'Estimated AWS MRR',
    placeHolder: '',
    id: 'expectedMonthlyAwsRevenue',
    isRequired: true,
    humanReadableKey: 'Labra__Expected_Monthly_AWS_Revenue__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'integer',
  },
  {
    title: 'Target close date',
    placeHolder: '',
    id: 'targetCloseDate',
    isRequired: true,
    humanReadableKey: 'Labra__Target_Close_Date__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'date',
  },
  {
    title: 'Description',
    placeHolder: '',
    id: 'customerBusinessProblem',
    isRequired: true,
    humanReadableKey: 'Labra__Description__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'textarea_auto_size',
    columns: 12,
    rows: 3,
    info: "Customer business problem refers to a specific challenge or issue affecting the customer's operations, goals, or performance. When you create an opportunity, it’s important to provide a clear and concise problem statement, offer relevant context and background information, highlight the customer’s pain points and their impact on the business, and describe how your proposed solution addresses the customer’s needs.",
  },
  {
    title: 'Opportunity type',
    placeHolder: '',
    id: 'opportunityType',
    isRequired: true,
    humanReadableKey: 'Labra__Opportunity_Type__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: opportunityTypeOptions,
  },
  {
    title: 'Parent opportunity ID (Optional)',
    placeHolder: '',
    id: 'parentOpportunityId',
    isRequired: false,
    humanReadableKey: 'Labra__Parent_Opportunity_ID__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
    maxLength: 20,
  },
  {
    title: 'Solution offered',
    placeHolder: '',
    id: 'solutionOffered',
    isRequired: true,
    humanReadableKey: 'Labra__Solution_offered__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'multi_enum',
    columns: 12,
    options: [],
  },
  {
    title: 'Other solution offered',
    placeHolder: '',
    id: 'otherSolutionOffered',
    isRequired: false,
    humanReadableKey: 'Labra__Other_Solution_Offered__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
    columns: 12,
  },
  {
    title: 'Delivery model',
    placeHolder: '',
    id: 'deliveryModel',
    isRequired: true,
    humanReadableKey: 'Labra__Delivery_Model__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'multi_enum',
    columns: 12,
    options: deliveryModelOptions,
  },
  {
    title: 'Use case',
    placeHolder: '',
    id: 'useCase',
    isRequired: true,
    humanReadableKey: 'Labra__Use_Case__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: useCaseOptions,
  },
  {
    title: 'Opportunity owner',
    placeHolder: '',
    id: 'opportunityOwnerEmail',
    isRequired: true,
    humanReadableKey: 'Labra__AWS_Partner_Central_User_Email__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
  },
  {
    title: 'Partner primary need from AWS',
    placeHolder: '',
    id: 'partnerPrimaryNeedFromAws',
    isRequired: true,
    humanReadableKey: 'Labra__Primary_Need_From_AWS_MultiSelect__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'multi_enum',
    columns: 12,
    options: partnerPrimaryNeedFromAWSOptions,
    info: '',
  },
  {
    title: 'Sales activities',
    placeHolder: '',
    id: 'salesActivities',
    isRequired: true,
    humanReadableKey: 'Labra__Sales_Activities__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'multi_enum',
    columns: 12,
    options: salesActivitiesOptions,
  },
  {
    title: 'Additional comments (Optional)',
    placeHolder: '',
    id: 'additionalComments',
    isRequired: false,
    humanReadableKey: 'Labra__Additional_Comments__c',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
    columns: 12,
  },
]

export const leadCustomerDetailsFields: Array<FormField> = [
  {
    title: 'Customer name (Optional)',
    placeHolder: '',
    id: 'fullName',
    isRequired: false,
    humanReadableKey: 'fullName',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Customer title (Optional)',
    placeHolder: '',
    id: 'title',
    isRequired: false,
    humanReadableKey: 'title',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Customer email (Optional)',
    placeHolder: '',
    id: 'email',
    isRequired: false,
    humanReadableKey: 'email',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Customer phone (Optional)',
    placeHolder: '',
    id: 'phone',
    isRequired: false,
    humanReadableKey: 'phone',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Enter your address (Optional)',
    placeHolder: '',
    id: 'address',
    isRequired: false,
    humanReadableKey: 'address',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'City (Optional)',
    placeHolder: '',
    id: 'city',
    isRequired: false,
    humanReadableKey: 'city',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'State (Optional)',
    placeHolder: '',
    id: 'state',
    isRequired: false,
    humanReadableKey: 'state',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: stateOptions,
  },
  {
    title: 'Select a country',
    placeHolder: '',
    id: 'country',
    isRequired: true,
    humanReadableKey: 'country',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: countryOptions,
  },
  {
    title: 'Postal code',
    placeHolder: '',
    id: 'postalCode',
    isRequired: false,
    humanReadableKey: 'postalCode',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Website',
    placeHolder: '',
    id: 'website',
    isRequired: true,
    humanReadableKey: 'website',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Company name',
    placeHolder: '',
    id: 'companyName',
    isRequired: true,
    humanReadableKey: 'companyName',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
]
export const leadDetailsFields: Array<FieldUI & FormField> = [
  {
    title: 'Partner CRM lead Id',
    placeHolder: '',
    id: 'partnerCRMLeadId',
    isRequired: true,
    humanReadableKey: 'partnerCRMLeadId',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Segment company size',
    placeHolder: '',
    id: 'segmentCompanySize',
    isRequired: true,
    humanReadableKey: 'segmentCompanySize',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Use case workload',
    placeHolder: '',
    id: 'useCaseWorkload',
    isRequired: true,
    humanReadableKey: 'useCaseWorkload',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: [
      'Big Data',
      'Content Delivery',
      'DR/Archive/Backup',
      'High Performance Computing (HPC)',
      'IOT',
      'Marketplace',
      'Microsoft Apps',
      'Oracle/SAP/Enterprise Apps',
      'Other',
      'Web Application',
    ],
  },
  {
    title: 'Project description',
    placeHolder: '',
    id: 'projectDescription',
    isRequired: true,
    humanReadableKey: 'projectDescription',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'textarea',
    columns: 12,
    rows: 5,
    height: 120,
  },
  {
    title: 'Industry',
    placeHolder: '',
    id: 'industry',
    isRequired: true,
    humanReadableKey: 'industry',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'enum',
    options: [
      'Aerospace',
      'Agriculture',
      'Automotive',
      'Computers & Electronics',
      'Consumer Goods',
      'Education',
      'Financial Services',
      'Gaming',
      'Government',
      'Healthcare',
      'Hospitality',
      'Life Sciences',
      'Manufacturing',
      'Marketing & Advertising',
      'Media & Entertainment',
      'Mining',
      'Non-Profit Organization',
      'Energy - Oil & Gas',
      'Other',
      'Energy - Power & Utilities',
      'Professional Services',
      'Real Estate & Construction',
      'Retail',
      'Software & Internet',
      'Telecommunications',
      'Transportation & Logistics',
      'Travel',
      'Wholesale & Distribution',
    ],
  },
  {
    title: 'Lead status reason',
    placeHolder: '',
    id: 'leadStatusReason',
    isRequired: true,
    humanReadableKey: 'leadStatusReason',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Lead owner name',
    placeHolder: '',
    id: 'leadOwnerName',
    isRequired: true,
    humanReadableKey: 'leadOwnerName',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
  {
    title: 'Lead owner email',
    placeHolder: '',
    id: 'leadOwnerEmail',
    isRequired: true,
    humanReadableKey: 'leadOwnerEmail',
    isReadOnly: false,
    isCustom: false,
    defaultValue: undefined,
    dataType: 'string',
  },
]
export const referralsListPageSize = 50
export const allowFieldsForActionRequired = [
  'targetCloseDate',
  'country',
  'state',
  'city',
  'postalCode',
  'streetAddress',
  'website',
  'customerBusinessProblem',
  'expectedMonthlyAwsRevenue',
]

export const LinkedPrivateOfferProductTypeOptions = [
  {
    key: 'AmiProduct',
    label: 'AMI',
  },
  {
    key: 'ContainerProduct',
    label: 'Container',
  },
  {
    key: 'SaaSProduct',
    label: 'SaaS',
  },
  {
    key: 'DataProduct',
    label: 'Professional service',
  },
]
